import { render, staticRenderFns } from "./app_version_dialog.vue?vue&type=template&id=67325325"
import script from "./app_version_dialog.vue?vue&type=script&lang=js"
export * from "./app_version_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports